import { render } from "./SellerRetributionConfiguration.vue?vue&type=template&id=eb009d52"
import script from "./SellerRetributionConfiguration.vue?vue&type=script&lang=js"
export * from "./SellerRetributionConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__